import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const FlexContainer = (props) => {
    var _a;
    const horizontal = (_a = props.horizontal) !== null && _a !== void 0 ? _a : false;
    const flexClass = horizontal ? 'flexRow' : 'flexColumn';
    const stickToBottomClass = props.stickToBottom ? ' stickToBottom' : '';
    const flexProp = getFlexProp(props.flex);
    const gapPropKey = getGapPropKey(horizontal);
    return (_jsx(_Fragment, { children: _jsx("div", { className: `${flexClass}${stickToBottomClass}`, style: Object.assign({ backgroundColor: props.backgroundColor, flex: flexProp, [gapPropKey]: props.gap, padding: props.padding, boxSizing: 'border-box', width: props.width, maxWidth: props.maxWidth, height: props.height }, props.style), children: props.children }) }));
};
export function getFlexProp(flex) {
    var _a;
    return flex === undefined ? undefined : typeof (flex) === 'string' ? flex :
        `${(_a = flex.flexGrow) !== null && _a !== void 0 ? _a : 0}${flex.flexShrink ? ` ${flex.flexShrink}` : ''}${flex.flexBasis ? ` ${flex.flexBasis}` : ''}`;
}
export function getGapPropKey(horizontal) {
    return horizontal ? 'columnGap' : 'rowGap';
}
//# sourceMappingURL=FlexContainer.js.map